import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

const ConfirmDialog = ({
  open,
  onClose,
  onClickConfirm = undefined,
  title = "",
  message = "",
  confirmLabel = "Yes",
}) => {
  return (
    <div>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle
          sx={{
            textTransform: "capitalize",
          }}
        >
          {title}
        </DialogTitle>
        <DialogContent sx={{ minWidth: "400px" }}>
          <DialogContentText>{message}</DialogContentText>
        </DialogContent>
        <DialogActions sx={{ mb: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              onClickConfirm();
              onClose();
            }}
            sx={{ mr: 1 }}
          >
            {confirmLabel}
          </Button>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ConfirmDialog;
